import styled from 'styled-components';
import { Grid, Chip, Card, Divider } from '@mui/material';
import Typography from '@atoms/Typography';
import { devices, deviceSizes } from 'config/devices';
import Avatar from '@atoms/Avatar';

export const OpportunityMeta = styled(Typography)`
  display: flex;
  align-items: center;
  width: 100%;
  && {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    color: ${({ primary, theme }) => (primary ? theme.red[900] : theme.secondaryColor[700])};
  }

  svg {
    margin-right: 25px;
    width: 1.2rem;
    height: 1.2rem;
  }

  ${({ maxLines }) =>
    maxLines &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${maxLines};
    
    `}
`;
export const ShareBox = styled.div`
  display: flex;
  margin-top: 20px;
  width: 50%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${deviceSizes.sm}){
    width: 95%;
  }
`;

export const DedaLine = styled(Typography)`
  display: flex;
  align-items: center;
  width: 100%;
  && {
    margin-bottom: 50px;
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.red[900]} !important;
  }

  svg {
    margin-right: 25px;
    width: 1.2rem;
    height: 1.2rem;
  }

  ${({ maxLines }) =>
    maxLines &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${maxLines};
    
    `}
`;

export const ActionsContainer = styled(Grid)`
  flex-direction: row;
  display: flex;
  align-items: center;

  && {
    padding: 1rem 0;
    hr {
      display: flex;

      flex-grow: 2;
    }
  }
`;

export const BodyContainer = styled(Card)`
  margin-top: 1rem;
  padding: 3.6875rem 4.625rem;

  @media ${devices.sm} {
    margin-top: 8rem;
  }
  @media ${devices.xs} {
    padding: 1rem 1.5rem;
  }
  && {
    border-radius: 16px;
    width: 720px;
  }
`;

export const SectionDivider = styled(Divider)`
  && {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    width: 100%;
  }
`;

export const ChipsContainer = styled.div`
  /* width: 100%; */
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  .MuiChip-root {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const BodyText = styled.div`
  // font-size: 1.125rem;
  margin: 0.5rem 4rem;
  .MuiTypography-body1 {
    // font-size: 1.125rem;
    color: ${({ theme }) => theme.secondaryColor[700]};
  }
  pre {
    color: ${({ theme }) => theme.secondaryColor[700]};
  }
  h6 {
    color: ${({ theme }) => theme.secondaryColor[600]};
  }
  @media (max-width: ${deviceSizes.sm}) {
    margin: 0.5rem 2rem
  }
`;
export const OrgAvatar = styled(Avatar)`
  border: 2px solid ${({ theme }) => theme.primary.main};

`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-bottom: 1rem;
  .MuiAvatar-root {
    width: 64px;
    height: 64px;
    margin-right: 20px;
  }
  .MuiBox-root {
    width: 36px;
    height: 36px;
    position: absolute;
    left: -15px;
    bottom: 2px;
    background-color: ${({ theme }) => theme.primary.main};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 10px;
  }
`;

export const StyledChip = styled(Chip)`
  && {
    background-color: ${({ theme }) => theme.secondaryColor[50]};
  }
`;
